import module from 'nominas/nomina/module.js'

const schema = {
  calculo_fecha: 'timestamp',
  importe_divisa: 'number',
  importe: 'number',
  neto: 'number',
  comision_importe: 'number',
  comision_porcentaje: 'number',
  acumulado: {
    percepciones: {
      importe: 'number',
      gravado: 'number',
      exento: 'number',
    },
  },
  deducciones: {
    importe: 'number',
    gravado: 'number',
    exento: 'number',
    dias: 'number',
    id_concepto: 'number',
    horas: 'number',
    impuesto_estatal: 'number',
    complemento: 'number',
  },
  percepciones: {
    importe: 'number',
    gravado: 'number',
    exento: 'number',
    dias: 'number',
    impuesto_estatal: 'number',
    id_concepto: 'number',
    horas: 'number',
    complemento: 'number',
  },
  incapacidades: {
    dias_pagados: 'number',
    importe: 'number',
  },
  total_prestamos: 'number',
  total_servicios: 'number',
  config: {
    absorber_cuota_obrera: 'number',
    absorber_cuota_patronal: 'number',
    absorber_impuesto_estatal: 'number',
    absorber_isr: 'number',
    aguinaldo_exento: 'number',
    asimilados_acumulado: 'number',
    carga_social_pendiente: 'number',
    clase_prima_riesgo: 'number',
    cobro_carga_social: 'boolean',
    dias_carga_social: 'number',
    dias_pendientes_incapacidad: 'number',
    fecha_baja: 'date',
    fecha_imss_alta: 'date',
    fecha_imss_baja: 'date',
    fecha_ingreso: 'date',
    fecha_suspension: 'date',
    fonacot_pendiente: 'number',
    fonacot_pendiente_saldo: 'number',
    id_estado: 'number',
    id_regimen_fiscal: 'number',
    id_tipo_nomina: 'number',
    id_tipo_pension_alimenticia: 'number',
    infonavit_deduccion_valor: 'number',
    infonavit_pendiente: 'number',
    infonavit_pendiente_saldo: 'number',
    isr_acumulado: 'number',
    prima_riesgo: 'number',
    prima_vacacional_exento: 'number',
    reparto_utilidades_exento: 'number',
    salario_diario: 'number',
    salario_diario_integrado: 'number',
    salario_mensual: 'number',
    subsidio_acumulado: 'number',
    pension_alimenticia_valor: 'number',
    pagadora_carga_social: 'number',
    pagadora_impuesto_estatal: 'number',
    pagadora_isr: 'number',
    subsidioDeterminado: 'number',
    impuestoDeterminado: 'number',
    isr: 'number',
    imss_fondo_retiro_p: 'number',
    imss_riesgo_trabajo_p: 'number',
    imss_infonavit_p: 'number',
    imss_guarderia_p: 'number',
    imss_invalidez_p: 'number',
    imss_invalidez_t: 'number',
    imss_cesantia_p: 'number',
    imss_cesantia_t: 'number',
    imss_cuota_fija_p: 'number',
    imss_cuota_adicional_p: 'number',
    imss_cuota_adicional_t: 'number',
    imss_prestaciones_p: 'number',
    imss_prestaciones_t: 'number',
    imss_empresa: 'number',
    carga_social: 'number',
    cuota_obrera: 'number',
    cuota_patronal: 'number',
    impuesto_estatal: 'number',
    salario_diario_real: 'number',
    fondo_ahorro_real: 'number',
  },
  otros: 'number',
  dias_trabajados: 'number',
  status_calculado: 'boolean',
  estatus_remunerado: 'boolean',
  total_percepciones: 'number',
  total_deducciones: 'number',
  neto_a_pagar: 'number',
  prevision_social: 'number',
  suministro: 'number',
  comision: 'number',
  carga_social: 'number',
  impuesto_estatal: 'number',
  subtotal: 'number',
  iva: 'number',
  total: 'number',
}

export default class NominasNominaStatusCalculadoService {
  constructor ($http, $filter) {
    this.$http = $http
    this.$filter = $filter
  }

  put (idProyecto, idNomina, data) {
    //data = this.$filter('orderBy')(data.colaboradores, ['id_empresa', 'id_empleado'])

    return this.$http.put('/api/nominas/calculo', data, {
      params: {
        id_proyecto: idProyecto,
        id_nomina: idNomina,
      },
      schema,
      clearCache: 'nominas',
    })
  }
}

module.service('NominasNominaStatusCalculado', NominasNominaStatusCalculadoService)



// WEBPACK FOOTER //
// ./src/nominas/nomina/services/Nomina/Status/Calculado.js